/* Generate this object in a C# .Net environment like https://dotnetfiddle.net/
using System;
using System.Linq;
					
public class Program
{
	public static void Main()
	{
		var json = "{" + TimeZoneInfo.GetSystemTimeZones()
			.GroupBy(t => t.StandardName)
			.OrderBy(g => g.Key)
			.Select(g => "\n\t\"" + g.Key + "\":" + new String(' ', 32 - g.Key.Length)
				+ "{"
					+ "displayName: \"" + g.First().DisplayName + "\", "
					+ "offsetInMinutes: " + g.First().BaseUtcOffset.TotalMinutes
					+ (g.First().SupportsDaylightSavingTime ? ", supportsDaylightSavingTime: true, daylightName: \"" + g.First().DaylightName + "\"" : "")
				+ "}")
			.Aggregate((a, b) => a + ", " + b)+ "\n}";
		Console.WriteLine(json);
	}
} */
export const TIMEZONE_INFO: {
    [name: string]: {
        displayName: string;
        offsetInMinutes: number;
        supportsDaylightSavingTime?: boolean;
        daylightName?: string;
    };
} = {
    "Afghanistan Standard Time": { displayName: "(UTC+04:30) Kabul", offsetInMinutes: 270 },
    "Alaskan Standard Time": {
        displayName: "(UTC-09:00) Alaska",
        offsetInMinutes: -540,
        supportsDaylightSavingTime: true,
        daylightName: "Alaskan Daylight Time",
    },
    "Aleutian Standard Time": {
        displayName: "(UTC-10:00) Aleutian Islands",
        offsetInMinutes: -600,
        supportsDaylightSavingTime: true,
        daylightName: "Aleutian Daylight Time",
    },
    "Altai Standard Time": {
        displayName: "(UTC+07:00) Barnaul, Gorno-Altaysk",
        offsetInMinutes: 420,
        supportsDaylightSavingTime: true,
        daylightName: "Altai Daylight Time",
    },
    "Arab Standard Time": { displayName: "(UTC+03:00) Kuwait, Riyadh", offsetInMinutes: 180 },
    "Arabian Standard Time": { displayName: "(UTC+04:00) Abu Dhabi, Muscat", offsetInMinutes: 240 },
    "Arabic Standard Time": {
        displayName: "(UTC+03:00) Baghdad",
        offsetInMinutes: 180,
        supportsDaylightSavingTime: true,
        daylightName: "Arabic Daylight Time",
    },
    "Argentina Standard Time": {
        displayName: "(UTC-03:00) City of Buenos Aires",
        offsetInMinutes: -180,
        supportsDaylightSavingTime: true,
        daylightName: "Argentina Daylight Time",
    },
    "Astrakhan Standard Time": {
        displayName: "(UTC+04:00) Astrakhan, Ulyanovsk",
        offsetInMinutes: 240,
        supportsDaylightSavingTime: true,
        daylightName: "Astrakhan Daylight Time",
    },
    "Atlantic Standard Time": {
        displayName: "(UTC-04:00) Atlantic Time (Canada)",
        offsetInMinutes: -240,
        supportsDaylightSavingTime: true,
        daylightName: "Atlantic Daylight Time",
    },
    "AUS Central Standard Time": { displayName: "(UTC+09:30) Darwin", offsetInMinutes: 570 },
    "Aus Central W. Standard Time": { displayName: "(UTC+08:45) Eucla", offsetInMinutes: 525 },
    "AUS Eastern Standard Time": {
        displayName: "(UTC+10:00) Canberra, Melbourne, Sydney",
        offsetInMinutes: 600,
        supportsDaylightSavingTime: true,
        daylightName: "AUS Eastern Daylight Time",
    },
    "Azerbaijan Standard Time": {
        displayName: "(UTC+04:00) Baku",
        offsetInMinutes: 240,
        supportsDaylightSavingTime: true,
        daylightName: "Azerbaijan Daylight Time",
    },
    "Azores Standard Time": {
        displayName: "(UTC-01:00) Azores",
        offsetInMinutes: -60,
        supportsDaylightSavingTime: true,
        daylightName: "Azores Daylight Time",
    },
    "Bahia Standard Time": {
        displayName: "(UTC-03:00) Salvador",
        offsetInMinutes: -180,
        supportsDaylightSavingTime: true,
        daylightName: "Bahia Daylight Time",
    },
    "Bangladesh Standard Time": {
        displayName: "(UTC+06:00) Dhaka",
        offsetInMinutes: 360,
        supportsDaylightSavingTime: true,
        daylightName: "Bangladesh Daylight Time",
    },
    "Belarus Standard Time": {
        displayName: "(UTC+03:00) Minsk",
        offsetInMinutes: 180,
        supportsDaylightSavingTime: true,
        daylightName: "Belarus Daylight Time",
    },
    "Bougainville Standard Time": {
        displayName: "(UTC+11:00) Bougainville Island",
        offsetInMinutes: 660,
        supportsDaylightSavingTime: true,
        daylightName: "Bougainville Daylight Time",
    },
    "Cabo Verde Standard Time": { displayName: "(UTC-01:00) Cabo Verde Is.", offsetInMinutes: -60 },
    "Canada Central Standard Time": {
        displayName: "(UTC-06:00) Saskatchewan",
        offsetInMinutes: -360,
    },
    "Caucasus Standard Time": {
        displayName: "(UTC+04:00) Yerevan",
        offsetInMinutes: 240,
        supportsDaylightSavingTime: true,
        daylightName: "Caucasus Daylight Time",
    },
    "Cen. Australia Standard Time": {
        displayName: "(UTC+09:30) Adelaide",
        offsetInMinutes: 570,
        supportsDaylightSavingTime: true,
        daylightName: "Cen. Australia Daylight Time",
    },
    "Central America Standard Time": {
        displayName: "(UTC-06:00) Central America",
        offsetInMinutes: -360,
    },
    "Central Asia Standard Time": { displayName: "(UTC+06:00) Astana", offsetInMinutes: 360 },
    "Central Brazilian Standard Time": {
        displayName: "(UTC-04:00) Cuiaba",
        offsetInMinutes: -240,
        supportsDaylightSavingTime: true,
        daylightName: "Central Brazilian Daylight Time",
    },
    "Central Europe Standard Time": {
        displayName: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
        offsetInMinutes: 60,
        supportsDaylightSavingTime: true,
        daylightName: "Central Europe Daylight Time",
    },
    "Central European Standard Time": {
        displayName: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
        offsetInMinutes: 60,
        supportsDaylightSavingTime: true,
        daylightName: "Central European Daylight Time",
    },
    "Central Pacific Standard Time": {
        displayName: "(UTC+11:00) Solomon Is., New Caledonia",
        offsetInMinutes: 660,
    },
    "Central Standard Time": {
        displayName: "(UTC-06:00) Central Time (US & Canada)",
        offsetInMinutes: -360,
        supportsDaylightSavingTime: true,
        daylightName: "Central Daylight Time",
    },
    "Central Standard Time (Mexico)": {
        displayName: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
        offsetInMinutes: -360,
        supportsDaylightSavingTime: true,
        daylightName: "Central Daylight Time (Mexico)",
    },
    "Chatham Islands Standard Time": {
        displayName: "(UTC+12:45) Chatham Islands",
        offsetInMinutes: 765,
        supportsDaylightSavingTime: true,
        daylightName: "Chatham Islands Daylight Time",
    },
    "China Standard Time": {
        displayName: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
        offsetInMinutes: 480,
    },
    "Coordinated Universal Time": {
        displayName: "(UTC) Coordinated Universal Time",
        offsetInMinutes: 0,
    },
    "Cuba Standard Time": {
        displayName: "(UTC-05:00) Havana",
        offsetInMinutes: -300,
        supportsDaylightSavingTime: true,
        daylightName: "Cuba Daylight Time",
    },
    "Dateline Standard Time": {
        displayName: "(UTC-12:00) International Date Line West",
        offsetInMinutes: -720,
    },
    "E. Africa Standard Time": { displayName: "(UTC+03:00) Nairobi", offsetInMinutes: 180 },
    "E. Australia Standard Time": { displayName: "(UTC+10:00) Brisbane", offsetInMinutes: 600 },
    "E. Europe Standard Time": {
        displayName: "(UTC+02:00) Chisinau",
        offsetInMinutes: 120,
        supportsDaylightSavingTime: true,
        daylightName: "E. Europe Daylight Time",
    },
    "E. South America Standard Time": {
        displayName: "(UTC-03:00) Brasilia",
        offsetInMinutes: -180,
        supportsDaylightSavingTime: true,
        daylightName: "E. South America Daylight Time",
    },
    "Easter Island Standard Time": {
        displayName: "(UTC-06:00) Easter Island",
        offsetInMinutes: -360,
        supportsDaylightSavingTime: true,
        daylightName: "Easter Island Daylight Time",
    },
    "Eastern Standard Time": {
        displayName: "(UTC-05:00) Eastern Time (US & Canada)",
        offsetInMinutes: -300,
        supportsDaylightSavingTime: true,
        daylightName: "Eastern Daylight Time",
    },
    "Eastern Standard Time (Mexico)": {
        displayName: "(UTC-05:00) Chetumal",
        offsetInMinutes: -300,
        supportsDaylightSavingTime: true,
        daylightName: "Eastern Daylight Time (Mexico)",
    },
    "Egypt Standard Time": {
        displayName: "(UTC+02:00) Cairo",
        offsetInMinutes: 120,
        supportsDaylightSavingTime: true,
        daylightName: "Egypt Daylight Time",
    },
    "Fiji Standard Time": {
        displayName: "(UTC+12:00) Fiji",
        offsetInMinutes: 720,
        supportsDaylightSavingTime: true,
        daylightName: "Fiji Daylight Time",
    },
    "FLE Standard Time": {
        displayName: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
        offsetInMinutes: 120,
        supportsDaylightSavingTime: true,
        daylightName: "FLE Daylight Time",
    },
    "Georgian Standard Time": { displayName: "(UTC+04:00) Tbilisi", offsetInMinutes: 240 },
    "GMT Standard Time": {
        displayName: "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
        offsetInMinutes: 0,
        supportsDaylightSavingTime: true,
        daylightName: "GMT Daylight Time",
    },
    "Greenland Standard Time": {
        displayName: "(UTC-03:00) Greenland",
        offsetInMinutes: -180,
        supportsDaylightSavingTime: true,
        daylightName: "Greenland Daylight Time",
    },
    "Greenwich Standard Time": {
        displayName: "(UTC+00:00) Monrovia, Reykjavik",
        offsetInMinutes: 0,
    },
    "GTB Standard Time": {
        displayName: "(UTC+02:00) Athens, Bucharest",
        offsetInMinutes: 120,
        supportsDaylightSavingTime: true,
        daylightName: "GTB Daylight Time",
    },
    "Haiti Standard Time": {
        displayName: "(UTC-05:00) Haiti",
        offsetInMinutes: -300,
        supportsDaylightSavingTime: true,
        daylightName: "Haiti Daylight Time",
    },
    "Hawaiian Standard Time": { displayName: "(UTC-10:00) Hawaii", offsetInMinutes: -600 },
    "India Standard Time": {
        displayName: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
        offsetInMinutes: 330,
    },
    "Iran Standard Time": {
        displayName: "(UTC+03:30) Tehran",
        offsetInMinutes: 210,
        supportsDaylightSavingTime: true,
        daylightName: "Iran Daylight Time",
    },
    "Jerusalem Standard Time": {
        displayName: "(UTC+02:00) Jerusalem",
        offsetInMinutes: 120,
        supportsDaylightSavingTime: true,
        daylightName: "Jerusalem Daylight Time",
    },
    "Jordan Standard Time": {
        displayName: "(UTC+02:00) Amman",
        offsetInMinutes: 120,
        supportsDaylightSavingTime: true,
        daylightName: "Jordan Daylight Time",
    },
    "Kamchatka Standard Time": {
        displayName: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
        offsetInMinutes: 720,
        supportsDaylightSavingTime: true,
        daylightName: "Kamchatka Daylight Time",
    },
    "Korea Standard Time": { displayName: "(UTC+09:00) Seoul", offsetInMinutes: 540 },
    "Libya Standard Time": {
        displayName: "(UTC+02:00) Tripoli",
        offsetInMinutes: 120,
        supportsDaylightSavingTime: true,
        daylightName: "Libya Daylight Time",
    },
    "Line Islands Standard Time": {
        displayName: "(UTC+14:00) Kiritimati Island",
        offsetInMinutes: 840,
    },
    "Lord Howe Standard Time": {
        displayName: "(UTC+10:30) Lord Howe Island",
        offsetInMinutes: 630,
        supportsDaylightSavingTime: true,
        daylightName: "Lord Howe Daylight Time",
    },
    "Magadan Standard Time": {
        displayName: "(UTC+11:00) Magadan",
        offsetInMinutes: 660,
        supportsDaylightSavingTime: true,
        daylightName: "Magadan Daylight Time",
    },
    "Magallanes Standard Time": {
        displayName: "(UTC-03:00) Punta Arenas",
        offsetInMinutes: -180,
        supportsDaylightSavingTime: true,
        daylightName: "Magallanes Daylight Time",
    },
    "Malay Peninsula Standard Time": {
        displayName: "(UTC+08:00) Kuala Lumpur, Singapore",
        offsetInMinutes: 480,
    },
    "Marquesas Standard Time": {
        displayName: "(UTC-09:30) Marquesas Islands",
        offsetInMinutes: -570,
    },
    "Mauritius Standard Time": {
        displayName: "(UTC+04:00) Port Louis",
        offsetInMinutes: 240,
        supportsDaylightSavingTime: true,
        daylightName: "Mauritius Daylight Time",
    },
    "Mid-Atlantic Standard Time": {
        displayName: "(UTC-02:00) Mid-Atlantic - Old",
        offsetInMinutes: -120,
        supportsDaylightSavingTime: true,
        daylightName: "Mid-Atlantic Daylight Time",
    },
    "Middle East Standard Time": {
        displayName: "(UTC+02:00) Beirut",
        offsetInMinutes: 120,
        supportsDaylightSavingTime: true,
        daylightName: "Middle East Daylight Time",
    },
    "Montevideo Standard Time": {
        displayName: "(UTC-03:00) Montevideo",
        offsetInMinutes: -180,
        supportsDaylightSavingTime: true,
        daylightName: "Montevideo Daylight Time",
    },
    "Morocco Standard Time": {
        displayName: "(UTC+00:00) Casablanca",
        offsetInMinutes: 0,
        supportsDaylightSavingTime: true,
        daylightName: "Morocco Daylight Time",
    },
    "Mountain Standard Time": {
        displayName: "(UTC-07:00) Mountain Time (US & Canada)",
        offsetInMinutes: -420,
        supportsDaylightSavingTime: true,
        daylightName: "Mountain Daylight Time",
    },
    "Mountain Standard Time (Mexico)": {
        displayName: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
        offsetInMinutes: -420,
        supportsDaylightSavingTime: true,
        daylightName: "Mountain Daylight Time (Mexico)",
    },
    "Myanmar Standard Time": { displayName: "(UTC+06:30) Yangon (Rangoon)", offsetInMinutes: 390 },
    "Namibia Standard Time": {
        displayName: "(UTC+01:00) Windhoek",
        offsetInMinutes: 60,
        supportsDaylightSavingTime: true,
        daylightName: "Namibia Daylight Time",
    },
    "Nepal Standard Time": { displayName: "(UTC+05:45) Kathmandu", offsetInMinutes: 345 },
    "New Zealand Standard Time": {
        displayName: "(UTC+12:00) Auckland, Wellington",
        offsetInMinutes: 720,
        supportsDaylightSavingTime: true,
        daylightName: "New Zealand Daylight Time",
    },
    "Newfoundland Standard Time": {
        displayName: "(UTC-03:30) Newfoundland",
        offsetInMinutes: -210,
        supportsDaylightSavingTime: true,
        daylightName: "Newfoundland Daylight Time",
    },
    "Norfolk Standard Time": {
        displayName: "(UTC+11:00) Norfolk Island",
        offsetInMinutes: 660,
        supportsDaylightSavingTime: true,
        daylightName: "Norfolk Daylight Time",
    },
    "North Korea Standard Time": {
        displayName: "(UTC+08:30) Pyongyang",
        offsetInMinutes: 510,
        supportsDaylightSavingTime: true,
        daylightName: "North Korea Daylight Time",
    },
    "Novosibirsk Standard Time": {
        displayName: "(UTC+07:00) Novosibirsk",
        offsetInMinutes: 420,
        supportsDaylightSavingTime: true,
        daylightName: "Novosibirsk Daylight Time",
    },
    "Omsk Standard Time": {
        displayName: "(UTC+06:00) Omsk",
        offsetInMinutes: 360,
        supportsDaylightSavingTime: true,
        daylightName: "Omsk Daylight Time",
    },
    "Pacific SA Standard Time": {
        displayName: "(UTC-04:00) Santiago",
        offsetInMinutes: -240,
        supportsDaylightSavingTime: true,
        daylightName: "Pacific SA Daylight Time",
    },
    "Pacific Standard Time": {
        displayName: "(UTC-08:00) Pacific Time (US & Canada)",
        offsetInMinutes: -480,
        supportsDaylightSavingTime: true,
        daylightName: "Pacific Daylight Time",
    },
    "Pacific Standard Time (Mexico)": {
        displayName: "(UTC-08:00) Baja California",
        offsetInMinutes: -480,
        supportsDaylightSavingTime: true,
        daylightName: "Pacific Daylight Time (Mexico)",
    },
    "Pakistan Standard Time": {
        displayName: "(UTC+05:00) Islamabad, Karachi",
        offsetInMinutes: 300,
        supportsDaylightSavingTime: true,
        daylightName: "Pakistan Daylight Time",
    },
    "Paraguay Standard Time": {
        displayName: "(UTC-04:00) Asuncion",
        offsetInMinutes: -240,
        supportsDaylightSavingTime: true,
        daylightName: "Paraguay Daylight Time",
    },
    "Romance Standard Time": {
        displayName: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
        offsetInMinutes: 60,
        supportsDaylightSavingTime: true,
        daylightName: "Romance Daylight Time",
    },
    "Russia TZ 1 Standard Time": {
        displayName: "(UTC+02:00) Kaliningrad",
        offsetInMinutes: 120,
        supportsDaylightSavingTime: true,
        daylightName: "Russia TZ 1 Daylight Time",
    },
    "Russia TZ 10 Standard Time": {
        displayName: "(UTC+11:00) Chokurdakh",
        offsetInMinutes: 660,
        supportsDaylightSavingTime: true,
        daylightName: "Russia TZ 10 Daylight Time",
    },
    "Russia TZ 11 Standard Time": {
        displayName: "(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky",
        offsetInMinutes: 720,
        supportsDaylightSavingTime: true,
        daylightName: "Russia TZ 11 Daylight Time",
    },
    "Russia TZ 2 Standard Time": {
        displayName: "(UTC+03:00) Moscow, St. Petersburg, Volgograd",
        offsetInMinutes: 180,
        supportsDaylightSavingTime: true,
        daylightName: "Russia TZ 2 Daylight Time",
    },
    "Russia TZ 3 Standard Time": {
        displayName: "(UTC+04:00) Izhevsk, Samara",
        offsetInMinutes: 240,
        supportsDaylightSavingTime: true,
        daylightName: "Russia TZ 3 Daylight Time",
    },
    "Russia TZ 4 Standard Time": {
        displayName: "(UTC+05:00) Ekaterinburg",
        offsetInMinutes: 300,
        supportsDaylightSavingTime: true,
        daylightName: "Russia TZ 4 Daylight Time",
    },
    "Russia TZ 6 Standard Time": {
        displayName: "(UTC+07:00) Krasnoyarsk",
        offsetInMinutes: 420,
        supportsDaylightSavingTime: true,
        daylightName: "Russia TZ 6 Daylight Time",
    },
    "Russia TZ 7 Standard Time": {
        displayName: "(UTC+08:00) Irkutsk",
        offsetInMinutes: 480,
        supportsDaylightSavingTime: true,
        daylightName: "Russia TZ 7 Daylight Time",
    },
    "Russia TZ 8 Standard Time": {
        displayName: "(UTC+09:00) Yakutsk",
        offsetInMinutes: 540,
        supportsDaylightSavingTime: true,
        daylightName: "Russia TZ 8 Daylight Time",
    },
    "Russia TZ 9 Standard Time": {
        displayName: "(UTC+10:00) Vladivostok",
        offsetInMinutes: 600,
        supportsDaylightSavingTime: true,
        daylightName: "Russia TZ 9 Daylight Time",
    },
    "SA Eastern Standard Time": {
        displayName: "(UTC-03:00) Cayenne, Fortaleza",
        offsetInMinutes: -180,
    },
    "SA Pacific Standard Time": {
        displayName: "(UTC-05:00) Bogota, Lima, Quito, Rio Branco",
        offsetInMinutes: -300,
    },
    "SA Western Standard Time": {
        displayName: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
        offsetInMinutes: -240,
    },
    "Saint Pierre Standard Time": {
        displayName: "(UTC-03:00) Saint Pierre and Miquelon",
        offsetInMinutes: -180,
        supportsDaylightSavingTime: true,
        daylightName: "Saint Pierre Daylight Time",
    },
    "Sakhalin Standard Time": {
        displayName: "(UTC+11:00) Sakhalin",
        offsetInMinutes: 660,
        supportsDaylightSavingTime: true,
        daylightName: "Sakhalin Daylight Time",
    },
    "Samoa Standard Time": {
        displayName: "(UTC+13:00) Samoa",
        offsetInMinutes: 780,
        supportsDaylightSavingTime: true,
        daylightName: "Samoa Daylight Time",
    },
    "Saratov Standard Time": {
        displayName: "(UTC+04:00) Saratov",
        offsetInMinutes: 240,
        supportsDaylightSavingTime: true,
        daylightName: "Saratov Daylight Time",
    },
    "SE Asia Standard Time": {
        displayName: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
        offsetInMinutes: 420,
    },
    "South Africa Standard Time": {
        displayName: "(UTC+02:00) Harare, Pretoria",
        offsetInMinutes: 120,
    },
    "Sri Lanka Standard Time": {
        displayName: "(UTC+05:30) Sri Jayawardenepura",
        offsetInMinutes: 330,
    },
    "Sudan Standard Time": {
        displayName: "(UTC+02:00) Khartoum",
        offsetInMinutes: 120,
        supportsDaylightSavingTime: true,
        daylightName: "Sudan Daylight Time",
    },
    "Syria Standard Time": {
        displayName: "(UTC+02:00) Damascus",
        offsetInMinutes: 120,
        supportsDaylightSavingTime: true,
        daylightName: "Syria Daylight Time",
    },
    "Taipei Standard Time": { displayName: "(UTC+08:00) Taipei", offsetInMinutes: 480 },
    "Tasmania Standard Time": {
        displayName: "(UTC+10:00) Hobart",
        offsetInMinutes: 600,
        supportsDaylightSavingTime: true,
        daylightName: "Tasmania Daylight Time",
    },
    "Tocantins Standard Time": {
        displayName: "(UTC-03:00) Araguaina",
        offsetInMinutes: -180,
        supportsDaylightSavingTime: true,
        daylightName: "Tocantins Daylight Time",
    },
    "Tokyo Standard Time": {
        displayName: "(UTC+09:00) Osaka, Sapporo, Tokyo",
        offsetInMinutes: 540,
    },
    "Tomsk Standard Time": {
        displayName: "(UTC+07:00) Tomsk",
        offsetInMinutes: 420,
        supportsDaylightSavingTime: true,
        daylightName: "Tomsk Daylight Time",
    },
    "Tonga Standard Time": {
        displayName: "(UTC+13:00) Nuku'alofa",
        offsetInMinutes: 780,
        supportsDaylightSavingTime: true,
        daylightName: "Tonga Daylight Time",
    },
    "Transbaikal Standard Time": {
        displayName: "(UTC+09:00) Chita",
        offsetInMinutes: 540,
        supportsDaylightSavingTime: true,
        daylightName: "Transbaikal Daylight Time",
    },
    "Turkey Standard Time": {
        displayName: "(UTC+03:00) Istanbul",
        offsetInMinutes: 180,
        supportsDaylightSavingTime: true,
        daylightName: "Turkey Daylight Time",
    },
    "Turks and Caicos Standard Time": {
        displayName: "(UTC-04:00) Turks and Caicos",
        offsetInMinutes: -240,
        supportsDaylightSavingTime: true,
        daylightName: "Turks and Caicos Daylight Time",
    },
    "Ulaanbaatar Standard Time": {
        displayName: "(UTC+08:00) Ulaanbaatar",
        offsetInMinutes: 480,
        supportsDaylightSavingTime: true,
        daylightName: "Ulaanbaatar Daylight Time",
    },
    "US Eastern Standard Time": {
        displayName: "(UTC-05:00) Indiana (East)",
        offsetInMinutes: -300,
        supportsDaylightSavingTime: true,
        daylightName: "US Eastern Daylight Time",
    },
    "US Mountain Standard Time": { displayName: "(UTC-07:00) Arizona", offsetInMinutes: -420 },
    "UTC+12": { displayName: "(UTC+12:00) Coordinated Universal Time+12", offsetInMinutes: 720 },
    "UTC+13": { displayName: "(UTC+13:00) Coordinated Universal Time+13", offsetInMinutes: 780 },
    "UTC-02": { displayName: "(UTC-02:00) Coordinated Universal Time-02", offsetInMinutes: -120 },
    "UTC-08": { displayName: "(UTC-08:00) Coordinated Universal Time-08", offsetInMinutes: -480 },
    "UTC-09": { displayName: "(UTC-09:00) Coordinated Universal Time-09", offsetInMinutes: -540 },
    "UTC-11": { displayName: "(UTC-11:00) Coordinated Universal Time-11", offsetInMinutes: -660 },
    "Venezuela Standard Time": {
        displayName: "(UTC-04:00) Caracas",
        offsetInMinutes: -240,
        supportsDaylightSavingTime: true,
        daylightName: "Venezuela Daylight Time",
    },
    "W. Australia Standard Time": {
        displayName: "(UTC+08:00) Perth",
        offsetInMinutes: 480,
        supportsDaylightSavingTime: true,
        daylightName: "W. Australia Daylight Time",
    },
    "W. Central Africa Standard Time": {
        displayName: "(UTC+01:00) West Central Africa",
        offsetInMinutes: 60,
    },
    "W. Europe Standard Time": {
        displayName: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
        offsetInMinutes: 60,
        supportsDaylightSavingTime: true,
        daylightName: "W. Europe Daylight Time",
    },
    "W. Mongolia Standard Time": {
        displayName: "(UTC+07:00) Hovd",
        offsetInMinutes: 420,
        supportsDaylightSavingTime: true,
        daylightName: "W. Mongolia Daylight Time",
    },
    "West Asia Standard Time": {
        displayName: "(UTC+05:00) Ashgabat, Tashkent",
        offsetInMinutes: 300,
    },
    "West Bank Gaza Standard Time": {
        displayName: "(UTC+02:00) Gaza, Hebron",
        offsetInMinutes: 120,
        supportsDaylightSavingTime: true,
        daylightName: "West Bank Gaza Daylight Time",
    },
    "West Pacific Standard Time": {
        displayName: "(UTC+10:00) Guam, Port Moresby",
        offsetInMinutes: 600,
    },
};
